export default __webpack_public_path__ + "static/appleFooterOnHover-3e25cc9210c41d49b9d05b4de67f3ee1.svg";